import type { InstrumentSources } from './types'

/** The sources read as the hook reports it: not yet answered, answered, or failed. */
export type SourcesView = { status: 'loading' } | { status: 'loaded'; sources: InstrumentSources } | { status: 'error' }

/**
 * Spec 073 B4: the display label of an instrument, `NQ (Databento)`. The stored
 * and wire value stays the bare name. Before the sources answer the bare name
 * shows (no flicker of an unknown source); after a failed read, or for a name the
 * server maps to nothing, it reads `(unknown source)`.
 */
export function formatInstrument(name: string, sources: SourcesView | null): string {
  if (sources === null || sources.status === 'loading') return name
  if (sources.status === 'error') return `${name} (unknown source)`
  return `${name} (${sources.sources.sources[name] ?? sources.sources.fallback})`
}
